'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PreLoader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../identifiers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PreLoader = (_temp2 = _class = function (_PureComponent) {
	_inherits(PreLoader, _PureComponent);

	function PreLoader() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, PreLoader);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PreLoader.__proto__ || Object.getPrototypeOf(PreLoader)).call.apply(_ref, [this].concat(args))), _this), _this.getSize = function () {
			var size = _this.props.size;
			return 'size' + size.charAt(0).toUpperCase() + size.slice(1);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(PreLoader, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    size = _props.size,
			    invert = _props.invert,
			    theme = _props.theme;

			var classNamesPreloader = (0, _classnames4.default)(theme.PreLoader, _defineProperty({}, theme['' + this.getSize()], true), className);
			var classNamesSvgPath = (0, _classnames4.default)(theme.PreLoader_svg_path, _defineProperty({}, theme.inverted, invert));

			return _react2.default.createElement(
				'div',
				{ className: classNamesPreloader },
				_react2.default.createElement(
					'svg',
					{ className: this.props.theme.PreLoader_svg, viewBox: '0 0 60 60' },
					_react2.default.createElement('circle', { className: classNamesSvgPath, cx: '30', cy: '30', r: '25' })
				)
			);
		}
	}]);

	return PreLoader;
}(_react.PureComponent), _class.propTypes = {
	className: _propTypes2.default.string,
	invert: _propTypes2.default.bool,
	size: _propTypes2.default.string,
	theme: _propTypes2.default.shape({
		PreLoader_svg: _propTypes2.default.string,
		PreLoader_svg_path: _propTypes2.default.string,
		invert: _propTypes2.default.string,
		size: _propTypes2.default.string
	})
}, _class.defaultProps = {
	className: '',
	invert: false,
	size: 'medium'
}, _temp2);
exports.default = (0, _reactCssThemr.themr)(_identifiers.PRE_LOADER)(PreLoader);
exports.PreLoader = PreLoader;


//////////////////
// WEBPACK FOOTER
// ./~/@wevo/react-components/lib/PreLoader/PreLoader.js
// module id = 912
// module chunks = 0